const ROUTES = {
  "/": {
    "name": "HomePage06188b8f84524ce88d83813d2df264db",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPageC068ed24384f4afeAf2c79317051d7be",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/local-partnership": {
    "name": "LocalPartnershipPage21465849D8b44ef4B4e479ba8b0a42aa",
    "type": "HTML",
    "key": "local-partnership-page"
  },
  "/apply/*": {
    "name": "ApplicationPages251c6d7e72bf4d6b901e4764ce406955",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/contact": {
    "name": "PublicContactPage1c62760f0fbc479fB71d921c799365aa",
    "type": "HTML",
    "key": "public-contact-page"
  },
  "/events/public": {
    "name": "PublicEventsPageB4ecb6e041ea4352A3b4Bb5dc703a0e5",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/faq": {
    "name": "PublicFaqPage665702911761440f8e59Bde815fc5d35",
    "type": "HTML",
    "key": "public-faq-page"
  },
  "/join": {
    "name": "JoinUsPage8e4e8f9e8f6e42af8692E17cd2690bba",
    "type": "HTML",
    "key": "join-us-page"
  }
};

export default ROUTES;